"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRefusTransportSoinsSheet = void 0;
const index_1 = require("../../index");
const makeRefusTransportSoinsSheet = () => {
    return [
        {
            '@type': 'grid',
            'key': '967f743b-2f85-4b41-9dd1-af26b9fccc36',
            columns: 1,
            children: [
                {
                    '@type': 'card',
                    key: '96298cba-b3ee-407c-9432-bca4b8cdc7b1',
                    title: 'Refus de transport et/ou soins',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '922d3096-f9aa-4450-abef-f20c51b4c6c1',
                            columns: 1,
                            children: [...index_1.template.refusTransportSoinsSheet],
                        },
                    ],
                },
            ],
        },
    ];
};
exports.makeRefusTransportSoinsSheet = makeRefusTransportSoinsSheet;
